export enum FormState {
  Idle = 'idle',
  Submitted = 'submitted',
  Submitting = 'submitting',
}
